export const formatMedicareNumber = (value) => {
    if (!value) return value;
    const currentValue = value.replace(/[^A-Za-z0-9]/g, '');
    const { length } = currentValue;

    if (length < 5) return currentValue;
    if (length < 8) return `${currentValue.slice(0, 4)}-${currentValue.slice(4)}`
    return `${currentValue.slice(0, 4)}-${currentValue.slice(4, 7)}-${currentValue.slice(7, 11)}`
}